import { render, staticRenderFns } from "./OrderComponentRaceChange.vue?vue&type=template&id=6c09050a&"
import script from "./OrderComponentRaceChange.vue?vue&type=script&lang=js&"
export * from "./OrderComponentRaceChange.vue?vue&type=script&lang=js&"
import style0 from "./OrderComponentRaceChange.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports